import { useSortedTags } from 'features/tags';
import { useClearTodayFilters } from 'features/user';
import React, { useEffect, useMemo } from 'react';
import { FilterBannerBase } from 'shared/components/ui/filter-banner-base';
import { useContextMenuState } from 'shared/hooks/use-context-menu-state';
import { useUser } from 'shared/hooks/use-user';

import { FilterContextMenu } from '../filter-context-menu';
import * as Styled from './active-filter-banner.style';

export const ActiveFilterBanner: React.FC = () => {
  const tags = useSortedTags();
  const user = useUser();
  const clearFilters = useClearTodayFilters();

  const {
    open: openMenu,
    close: closeMenu,
    position: menuPosition,
  } = useContextMenuState();

  const filteredTags = useMemo(
    () =>
      user?.settings?.todayFilterByTags?.length
        ? tags.filter(({ id }) =>
            user?.settings?.todayFilterByTags?.includes(id),
          )
        : [],
    [tags, user?.settings?.todayFilterByTags],
  );

  useEffect(() => {
    if (!filteredTags.length) {
      closeMenu();
    }
  }, [closeMenu, filteredTags.length]);

  return (
    <Styled.Container $open={!!filteredTags.length}>
      <FilterBannerBase
        tags={filteredTags}
        onTags={openMenu}
        onClear={clearFilters}
      />

      {!!menuPosition && (
        <FilterContextMenu onClose={closeMenu} location={menuPosition} />
      )}
    </Styled.Container>
  );
};
